/* CustomizeOrder UAT api url's */

export const BDVREQUEST_TN_URL = "https://wwwawsuataws.ebiz.verizon.com/foryoursmallbiz/so/api/qualify/BDVRequestTN";
export const FIOSNOSPEEDS_URL = "https://wwwawsuat.ebiz.verizon.com/foryoursmallbiz/so/common/lbo/lbo?Message=FIOSNOSPEEDS"

export const ENABLE_HOLIDAY_OFFER_DISCLAIMER = process.env.REACT_APP_ENABLE_HOLIDAY_OFFER_DISCLAIMER;
export const REACT_APP_ENABLE_TV_VMS_RECORDING = process.env.REACT_APP_ENABLE_TV_VMS_RECORDING;

export const phoneServiceLabels = {
    PHONE_SERVICE_TITLE: "Phone Service",
    PHONE_SERVICE_DESC: "Business Digital Voice allows you to manage calls from anywhere you have an internet connection with over 45 features. Standard Phone includes features like call forwarding and voicemail. Taxes, fees and equipment charges will be reflected in your cart. ",
    STANDARD_PHONE_DESC: "The Standard Phone is a traditional calling service provided on our reliable network.  It includes features like call forwarding and voicemail. ",
    COMPARE_PHONE_SERVICES: "Compare phone services",
    STANDARD_PHONE_DETAILS: "View details",
    PHONE_SERVICE_BDV: "Business Digital Voice",
    PHONE_SERVICE_SP: "Standard Phone",
    MODAL1_BDV_DESC: "Business Digital Voice is a voice over IP solution with unlimited long distance calling to anywhere in the U.S., Puerto Rico and the U.S. Virgin Islands. Internet service with speeds of 5Mbps or higher is required. Features include:",
    MODAL1_SP_DESC: "The Standard Phone Preferred Voice plan is a traditional calling service provided on our reliable network featuring:",
}

export const noOfLinesLabels = {
    NOL_LEARN_MORE_MODAL: "We have assigned a telephone number to each line so that it can be initially configured. Numbers can be re-configured and shared over multiple phones during installation or anytime using the online feature management tool.",
    UYON_MODAL_DESC: "We can check to see if your existing Business phone number can be transferred to Verizon. If you have multiple existing numbers you would like to transfer, please chat with one of our representatives who can check each number for you and assist in placing your order.",
    UYON_MODAL_DESC_1: "Please input the billing or primary telephone number on your account.",
}

export const standardPhoneLineLabels = {
    STANDARD_PHONE_LINE_DESC: "Some businesses require a standard phone line, such as faxing, credit card processing and some alarm systems. This line is outside of your Business Digital Voice plan and requires a standard phone jack.",

}

export const numberOfLinesList = [1, 2, 3, 4, 5];

export const phoneEquipmentLabels = {
    PHONE_EQUIPMENT_DESC_MOBILE: "IP phones are required to access all Business Digital Voice features.All phone equipment includes a 1-year warranty. Monthly prices below reflect ",
    PHONE_EQUIPMENT_DESC_DESKTOP: "IP phones are required to access all Business Digital Voice features. Monthly prices below reflect "
}

export const internetServiceOrder = [
    {
        heading: 'Internet speed',
        opened: true,
        className: 'InternetSpeed',
        selectedDetails: {},
        isOptional: false
    },
    
    {
        heading: 'Equipment',
        opened: false,
        className: 'Equipment',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Installation',
        opened: false,
        className: 'Installation',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Additional security and storage',
        opened: false,
        className: 'Additional-Security-Storage',
        selectedDetails: {},
        isOptional: false
    }
]

export const phoneServiceOrder = [
    {
        heading: 'Phone service',
        opened: true,
        className: 'PhoneService',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Phone setup',
        opened: true,
        className: 'NumberofLines',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Standard phone line',
        opened: false,
        className: 'StandardLine',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Select Phone equipment',
        opened: false,
        className: 'PhoneEquipment',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Add directory listing',
        opened: false,
        className: 'DirectoryListing',
        selectedDetails: {},
        isOptional: false
    },
    {
        heading: 'Power Reserve backup',
        opened: false,
        selectedDetails: {},
        className: 'PowerBackup',
        isOptional: false
    },

    {
        heading: 'Add Phone service',
        opened: false,
        selectedDetails: {},
        className: 'InternetService',
        isOptional: true
    },
    {
        heading: 'Add TV service',
        opened: false,
        selectedDetails: {},
        className: 'TVService',
        isOptional: true
    },
    {
        heading: 'Add Maintenance and Support services',
        opened: false,
        selectedDetails: {},
        className: 'PremiumSupport',
        isOptional: true
    },
    {
        heading: 'Contract agreement',
        mobileHeading:  'Select Contract Agreement',
        opened: false,
        selectedDetails: {},
        className: 'ContractAgreement',
        isOptional: true
    },
    {
        heading: 'Add Internet service',
        opened: false,
        selectedDetails: {},
        className: 'InternetService',
        isOptional: true
    },
    {
        heading: 'Small Business Solutions (frequently purchased add-ons)',
        opened: false,
        selectedDetails: {},
        className: 'PremiumSupport',
        isOptional: true
    },
    {
        heading: 'Add TV',
        opened: false,
        selectedDetails: {},
        className: 'TvAddon',
        isOptional: true
    },
    {
        heading: 'Static IP Address',
        opened: false,
        selectedDetails: {},
        className: 'StaticIP',
        isOptional: true
    },
];

export const IP_TYPES = {
    static: 'static',
    dynamic: 'dynamic'
};

export const tvServiceOrder = [
    {
        heading: 'Select TV viewing option',
        opened: true,
        className: 'ViewingOption',
        selectedDetails: {},
        selectedPrice: 0,
        isOptional: false
    },
    {
        heading: 'Select your plan',
        opened: false,
        className: 'TVPlan',
        selectedDetails: {},
        selectedPrice: 0,
        isOptional: false
    },
    {
        heading: 'Select TV equipment',
        opened: false,
        className: 'TVEquipment',
        selectedDetails: {},
        selectedPrice: 0,
        isOptional: false
    },
    {
        heading: 'Select a router',
        opened: false,
        className: 'TVRouter',
        selectedDetails: {},
        selectedPrice: 0,
        isOptional: false
    },
    {
        heading: 'Add premium and specialty channels',
        opened: false,
        className: 'PremiumChannels',
        selectedDetails: {},
        selectedPrice: 0,
        isOptional: true
    },
    {
        heading: 'Recording and storage',
        opened: false,
        className: 'TVRecording',
        selectedDetails: [],
        selectedPrice: 0,
        isOptional: true
    },
];

export const PRD_TYPES = {
    FIOS: "FIOSDATA",
    TV: "FIOSTV",
    HSI: "HSIDATA",
    BDV: "BDV",
    VOICE: "VOICE"
};

export const MONTH_CHARGES = {
    MONTH1: "Month 1",
    MONTH2: 'Month 2',
    MONTH3: 'Month 3',
    MONTH12: 'Month 12',
    MONTH2TO3: 'Months 2 - 3',
    MONTH4TO11: 'Months 4 - 11',
    MONTH4TO12: 'Months 4 - 12',
    MONTH13TO24: 'Months 13 - 24',
};

// Order is important. Please use proper order when changing.
export const MONTH_CHARGES_KEYS = [MONTH_CHARGES.MONTH1, MONTH_CHARGES.MONTH2, MONTH_CHARGES.MONTH3, MONTH_CHARGES.MONTH2TO3, MONTH_CHARGES.MONTH4TO11, MONTH_CHARGES.MONTH12, MONTH_CHARGES.MONTH4TO12, MONTH_CHARGES.MONTH13TO24];
// {
//     'gbportal.title': "."
//     'gbportal.AddressValidationPage.title'
// }
export const VCG_CMP = "vcgref:vcg_lq_business_direct"
